import { followUps } from '@/mocks/home';
import Reveal from '@/components/base/Reveal';

export default function FollowUpSection() {
  return (
    <section id="followup" className="w-full bg-background-50">
      <div className="mx-auto w-full max-w-6xl px-4 py-12 md:px-6 md:py-16">
        <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="text-xs font-medium tracking-[0.2em] text-primary-600">
              FOLLOW-UP
            </span>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              后续进展追踪
            </h2>
          </div>
          <p className="max-w-md text-sm leading-relaxed text-foreground-500 md:text-right">
            事件并未在峰值处结束。这一栏记录海角黑料后续的补充说明、阶段结论与话题走向。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-3">
          {followUps.map((item, index) => (
            <Reveal key={item.title} delay={index * 90}>
              <article className="flex h-full flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300">
                <div className="h-[180px] w-full overflow-hidden">
                  <img
                    src={item.image}
                    alt={`海角黑料后续进展 ${item.title}`}
                    title={`海角黑料后续 ${item.title}`}
                    className="h-full w-full object-top"
                  />
                </div>
                <div className="flex flex-1 flex-col p-5">
                  <div className="flex items-center gap-2">
                    <span className="rounded-full bg-secondary-100 px-2.5 py-1 text-[11px] font-medium text-secondary-800">
                      {item.tag}
                    </span>
                    <span className="font-heading text-xs font-bold text-foreground-500">
                      {item.date}
                    </span>
                  </div>
                  <h3 className="mt-3 font-heading text-base font-bold text-foreground-950">
                    {item.title}
                  </h3>
                  <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">
                    {item.desc}
                  </p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}